export const CONTRATO = Object.freeze({
  NOMINA_EMPLEADOS: 1,
  TERMINO_FIJO: 2,
  OPS: 3,
  APRENDIZAJE: 4,
});
